<template>
  <div>
    <!-- Empty state when no search performed -->
    <v-alert
      v-if="!searchStore.hasSearched"
      type="info"
      variant="tonal"
      class="ma-4 mx-auto"
      max-width="800"
      icon="mdi-information-outline"
    >
      {{ $t('strings.no-search-performed') }}
    </v-alert>

    <!-- Loading state -->
    <v-progress-linear
      v-if="searchStore.loading"
      indeterminate
      color="primary"
      class="mb-4"
      max-width="800"
    ></v-progress-linear>

    <!-- No results found -->
    <v-alert
      v-if="
        searchStore.hasSearched && !searchStore.loading && searchStore.filteredResults.length === 0
      "
      type="warning"
      variant="tonal"
      class="ma-4"
      icon="mdi-alert-circle-outline"
    >
      {{ $t('strings.no-results-found') }}
    </v-alert>

    <!-- Results data iterator -->
    <ResultsIterator
      :items="searchStore.filteredResults"
      :is-saved="isDatasetSaved"
      @toggle-save="searchStore.toggleSavedDataset"
    />
  </div>
</template>

<script setup>
import { useSearchStore } from '@/stores/search'
import ResultsIterator from '@/components/ResultsIterator.vue'

const searchStore = useSearchStore()

function isDatasetSaved(item) {
  return searchStore.isDatasetSaved(item.dataset_url)
}

</script>
